import React, { useState } from 'react';
import SearchableSelect from './SearchableSelect';
import PermissionEditor from './PermissionEditor';
import './UserGroupForm.css';

export default function UserGroupForm({ value, onChange, catalog, saving, onSubmit, onCancel, isNew = false }) {
  const [templateId, setTemplateId] = useState('');
  const prefix = isNew ? 'newGroup' : 'editingGroup';

  return (
    <form onSubmit={onSubmit}>
      <fieldset disabled={saving} className="configuration-form-fields user-group-form">
        {isNew && <div className="user-group-template">
          <div className="form-label">从模板开始（可选）</div>
          <SearchableSelect value={templateId} disabled={saving} placeholder="自定义分组"
            options={[{ value: '', label: '自定义分组' }, ...catalog.templates.map(template => ({ value: template.id, label: template.name }))]}
            onChange={id => {
              setTemplateId(id);
              const template = catalog.templates.find(item => item.id === id);
              onChange({ ...value, name: template?.name || '', description: template?.description || '', permissions: template?.permissions || [], is_active: true });
            }} />
        </div>}
        <section className="user-group-form-section" aria-label="基本信息">
          <h4>基本信息</h4>
          <div className="user-group-form-grid">
            <div className="form-group">
              <label className="form-label" htmlFor={`${prefix}-name`}>分组名称 *</label>
              <input id={`${prefix}-name`} className="form-input" value={value.name} required
                onChange={event => onChange({ ...value, name: event.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor={`${prefix}-description`}>描述</label>
              <input id={`${prefix}-description`} className="form-input" value={value.description || ''}
                onChange={event => onChange({ ...value, description: event.target.value })} />
            </div>
          </div>
        </section>
        <section className="user-group-form-section" aria-label="模块权限">
          <h4>模块权限</h4>
          <PermissionEditor idPrefix={isNew ? 'new-permission' : 'edit-permission'} value={value.permissions}
            catalog={catalog} onChange={permissions => onChange({ ...value, permissions })} />
        </section>
      </fieldset>
      <div className="configuration-dialog-actions">
        <button type="button" className="btn btn-ghost" disabled={saving} onClick={onCancel}>取消</button>
        <button type="submit" className="btn btn-primary" disabled={saving}>
          {saving ? (isNew ? '创建中…' : '保存中…') : (isNew ? '创建分组' : '保存分组')}
        </button>
      </div>
    </form>
  );
}
